module.exports = __webpack_public_path__ + "img/baggrund_small.bdfb07c9.png";